export const ARC_POST_PROCESSING_POLL_INTERVAL_MS = 10000;

// After an ARC engagement finishes processing, the backend submits it on its own and the
// upload status changes later. Polling stops once one of these outcomes is visible.
export const isArcPostProcessingSettled = (rec) => {
    if (!rec || rec._loading) return false;
    if (Number(rec.totalPendingFile || 0) > 0) return true;
    const status = String(rec.uploaD_STATUS || "").trim().toLowerCase();
    return (
        status === "submitted by arc" ||
        status === "submitted via arc" ||
        status === "failed upload" ||
        status.startsWith("download error")
    );
};
